import type { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Directive, ElementRef, HostBinding, inject, input } from '@angular/core';
import type { Observable, Subscription } from 'rxjs';
import { debounceTime, fromEvent } from 'rxjs';

import { type Position, positions } from '../../types/base/geometry.type';

@Directive({
  selector: '[evcIsScrollable]',
  standalone: true,
})
export class IsScrollableDirective implements OnInit, AfterViewInit, OnDestroy {
  #el = inject(ElementRef);

  @HostBinding('style.paddingLeft') paddingLeft = '0px';
  @HostBinding('style.paddingRight') paddingRight = '0px';
  @HostBinding('style.paddingTop') paddingTop = '0px';
  @HostBinding('style.paddingBottom') paddingBottom = '0px';

  readonly scrollPosition = input<Position>(positions.RIGHT);

  isScrollable?: boolean;

  #resizeSubscription?: Subscription;

  ngOnInit(): void {
    const resizeObservable: Observable<Event> = fromEvent(window, 'resize').pipe(debounceTime(300));
    this.#resizeSubscription = resizeObservable.subscribe(() => {
      this.checkScrollable();
    });
  }

  ngAfterViewInit(): void {
    this.checkScrollable();
  }

  ngOnDestroy(): void {
    if (this.#resizeSubscription) {
      this.#resizeSubscription.unsubscribe();
    }
  }

  checkScrollable(): void {
    const element: HTMLElement = this.#el.nativeElement;
    this.isScrollable =
      element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    this.#adjustPadding();
  }

  #adjustPadding(): void {
    if (this.isScrollable) {
      switch (this.scrollPosition()) {
        case 'left':
          this.paddingLeft = '2px';
          break;
        case 'right':
          this.paddingRight = '2px';
          break;
        case 'top':
          this.paddingTop = '2px';
          break;
        case 'bottom':
          this.paddingBottom = '2px';
          break;
        default:
          break;
      }
    } else {
      this.paddingLeft = '0px';
      this.paddingRight = '0px';
      this.paddingTop = '0px';
      this.paddingBottom = '0px';
    }
  }
}
